module.exports = __webpack_public_path__ + "img/cmt.261bdb55.svg";